import { adminAxiosInstance } from "./axiosInstance";
import { formatDateYMD } from "@dashboard/utils/formatDate";

interface Value {
    value: string;
}

interface Name {
    name: string;
}

export interface AnalyticsRow {
    dimensionValues: Value[];
    metricValues: Value[];
}

export interface AnalyticsReport {
    dimensionHeaders?: Name[] | null;
    metricHeaders?: Name[] | null;
    rows?: AnalyticsRow[] | null;
}

const getAnalyticsReport = async (
    customerId: number,
    startDate: Date,
    endDate: Date,
): Promise<AnalyticsReport> => {
    const params = new URLSearchParams();
    params.append("start", formatDateYMD(startDate));
    params.append("end", formatDateYMD(endDate));

    const url = `admin/analytics/report/customer/${customerId}?${params.toString()}`;
    const req = {
        dimensions: ["yearMonth", "unifiedPagePathScreen", "unifiedScreenName"],
        metrics: ["screenPageViews"],
    };

    return (await adminAxiosInstance.post(url, req)).data.data;
};

export { getAnalyticsReport };
